export const initCardLinks = (): void => {
  const tiles = document.querySelectorAll<HTMLElement>(
    ".hwk-blocks--teaser-tile[data-href], .hwk-blocks--hero-slider__slide[data-href]",
  );

  tiles.forEach((card) => {
    let startX = 0;
    let startY = 0;
    let dragged = false;
    const isSwiperSlide = card.classList.contains("swiper-slide");

    const navigateToCardLink = () => {
      const href = card.dataset.href;
      const target = card.dataset.target;

      console.log("navigateToCardLink", href, target);
      if (!href) {
        return;
      }

      if (target === "_blank") {
        window.open(href, "_blank", "noopener");
        return;
      }

      window.location.assign(href);
    };

    card.addEventListener("mousedown", (e) => {
      startX = e.clientX;
      startY = e.clientY;
      dragged = false;
    });

    card.addEventListener("mousemove", (e) => {
      if (
        Math.abs(e.clientX - startX) > 4 ||
        Math.abs(e.clientY - startY) > 4
      ) {
        dragged = true;
      }
    });

    card.addEventListener("click", (e) => {
      const target = e.target as HTMLElement | null;

      if (target?.closest("a, button, input, textarea, select, label")) {
        return;
      }

      const selection = window.getSelection();
      if (
        !isSwiperSlide &&
        (dragged || (selection && selection.toString().trim()))
      ) {
        return;
      }

      navigateToCardLink();
    });

    card.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        navigateToCardLink();
      }
    });
  });
};
